// extracted by mini-css-extract-plugin
export default {"container":"tG2to1","icon":"EF_vUC"};